import { MessageWidget } from './messageWidget';

export interface HpErrorWidgetProps {
  error: string | undefined;
}

export function ErrorWidget({ error }: HpErrorWidgetProps): JSX.Element | null {
  return <MessageWidget message={error} type="error" />;
}
